import { defineMessages } from 'react-intl';

const messages = defineMessages({
  //Start screen
  introTitle: {
    id: 'ODB53Y',
    defaultMessage:
      'Ready to test your knowledge about data breaches? Let’s get started.',
  },
  introCopy: {
    id: 'KePYGB',
    defaultMessage: `Today, the volume of data and diverse range of workloads make the journey towards data resilience more complex than ever. It requires a careful combination of hardware, software, strategic consulting and more, to minimize business impacts from cyberthreats. 
 
    This 10-question cyber resiliency assessment is a first step towards achieving end-to-end resilience for your organization. Let’s begin with identifying how prepared your organization is in the face of a cyberthreat. Then you can formulate a more comprehensive plan.`,
  },
  introButton: {
    id: '7lKCbS',
    defaultMessage: 'Play the game',
  },
  //Rules explanation
  ruleTitle: {
    id: 'ohMWF+',
    defaultMessage: `What are the rules?`,
  },
  ruleNumber1: {
    id: 'j2b516',
    defaultMessage: `You'll be presented with 10 random questions based on data security essentials, pop culture references, and IBM's annual Cost of a Data Breach Report 2024`,
  },
  ruleNumber2: {
    id: 'm4H1dG',
    defaultMessage: `Select an answer for each question.`,
  },
  ruleNumber3: {
    id: 'xksC1p',
    defaultMessage: `Need help? Click the “Ask for help” button to get the most likely answer. Or, eliminate two multiple-choice answers by clicking the “Double the chance” button. Both can be used only once.`,
  },
  ruleNumber4: {
    id: '7A3paG',
    defaultMessage: `You can take the quiz as many times as you like and be asked different questions.`,
  },
  //Questions
  //Related to 2024 Report:
  q1Title: {
    id: '2KXUyZ',
    defaultMessage: `What is the global average total cost of a breach, according to this year’s IBM’s 2024 Cost of a Data Breach Report ?  (Figures shown in USD)`,
    category: '2024-Report',
  },
  q2Title: {
    id: 'mKm4Sk',
    defaultMessage: `What percentage of organizations plan to increase security investments as a result of being breached, according to IBM’s 2024 Cost of a Data Breach Report?`,
    category: '2024-Report',
  },
  q3Title: {
    id: 'qhw+zb',
    defaultMessage: `Organizations that extensively used security AI and automation experienced what reduction in the average cost of a breach, according to IBM’s 2024 Cost of a Data Breach Report? (Figures shown in USD)`,
    category: '2024-Report',
  },
  q4Title: {
    id: 'tm54WE',
    defaultMessage: `How many industries did IBM’s 2024 Cost of a Data Breach Report examine?`,
    category: '2024-Report',
  },
  q5Title: {
    id: '29q6N3',
    defaultMessage:
      'According to IBM’s 2024 Cost of a Data Breach Report, what factor contributed to most of the cost increases for the average cost of a breach?',
    category: '2024-Report',
  },
  q6Title: {
    id: 'JEURy0',
    defaultMessage:
      'What percentage of organizations reported low disruption to their business operations from a data breach, according to  IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q7Title: {
    id: 'xhinnZ',
    defaultMessage:
      'What percentage of businesses took over 100 days to recover from a data breach incident, according to IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q8Title: {
    id: '07/Jnf',
    defaultMessage:
      'What method of breach identification was the highest in IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q9Title: {
    id: 'B0HdaL',
    defaultMessage:
      'What was the most common security investment of organizations studied in IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q10Title: {
    id: 'gGs6Sz',
    defaultMessage:
      'What initial attack vector took the longest for an organization to detect, according to IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q11Title: {
    id: '0juk+s',
    defaultMessage:
      'Ransom payments reached what amount, according to IBM’s 2024 Cost of a Data Breach Report? (Figures shown in USD)',
    category: '2024-Report',
  },
  q12Title: {
    id: 'GhpRdF',
    defaultMessage:
      'What was the most common type of record compromised, as reported in IBM’s 2024 Cost of a Data Breach Report?',
    category: '2024-Report',
  },
  q13Title: {
    id: '845BCo',
    defaultMessage:
      'How much did the average cost of a data breach increase year to year, according to IBM’s 2024 Cost of a Data Breach Report? (Figures shown in USD)',
    category: '2024-Report',
  },
  q14Title: {
    id: 'NEzWgC',
    defaultMessage:
      'According to the IBM’s 2024 Cost of a Data Breach Report, how many fewer days did it take organizations to identify and contain a data breach versus the previous year?',
    category: '2024-Report',
  },
  q15Title: {
    id: 'ax4MBr',
    defaultMessage:
      'According to the IBM’s 2024 Cost of a Data Breach Report, which environments proved more most vulnerable to a data breach?',
    category: '2024-Report',
  },
  q16Title: {
    id: 'r8bNNy',
    defaultMessage:
      'What is a key component of a security information and event management (SIEM) system?',
    category: '2024-Report',
  },
  q17Title: {
    id: 'cFC+nE',
    defaultMessage:
      'Which of the following is NOT a technique used in data masking to secure sensitive information?',
    category: '2024-Report',
  },
  //pop culture
  q18Title: {
    id: 'kfZIWO',
    defaultMessage:
      'Which movie features a protagonist hired to test a major corporation’s cybersecurity but then becomes embroiled in a conspiracy?',
    category: 'Pop-Culture',
  },
  q19Title: {
    id: 'w9qyh4',
    defaultMessage:
      'In the TV series "Mr. Robot," what hacking technique does the protagonist, Elliot Alderson, frequently use to gather information?',
    category: 'Pop-Culture',
  },
  q20Title: {
    id: '9sHUGa',
    defaultMessage:
      'What popular movie explores themes of AI, cybersecurity and the ethical implications of technology?',
    category: 'Pop-Culture',
  },
  q21Title: {
    id: 'YyTuYJ',
    defaultMessage:
      'What annual event held in Las Vegas is one of the world’s largest gatherings of hackers, security professionals and researchers?',
    category: 'Pop-Culture',
  },
  // q22Title: {
  //   id: '',
  //   defaultMessage:
  //     '',
  //   category: 'Pop-Culture',
  // },
  //Options-anwser
  q1option01: {
    id: '0JClIf',
    defaultMessage: '$4.88M', //correct
  },
  q1option02: {
    id: 'L8qYRh',
    defaultMessage: '$4.91M',
  },
  q1option03: {
    id: 'O5O66d',
    defaultMessage: '$4.56M',
  },
  q1option04: {
    id: 'y7ib6M',
    defaultMessage: '$3.86M',
  },
  ///////
  q2option01: {
    id: 'JU8BUQ',
    defaultMessage: '63%', //correct
  },
  q2option02: {
    id: 'XxYQVT',
    defaultMessage: '81%',
  },
  q2option03: {
    id: 'UNCgkY',
    defaultMessage: '54%',
  },
  q2option04: {
    id: '/69atZ',
    defaultMessage: '72%',
  },
  //////
  q3option01: {
    id: 'MldMvB',
    defaultMessage: '$1.88M', //correct
  },
  q3option02: {
    id: 'gDv5r5',
    defaultMessage: '$2.60M',
  },
  q3option03: {
    id: 'eFqvGH',
    defaultMessage: '$1.24M',
  },
  q3option04: {
    id: 'Oib1Bu',
    defaultMessage: '$3.58M',
  },
  ////////
  q4option01: {
    id: '3C3mfr',
    defaultMessage: '17', //correct
  },
  q4option02: {
    id: '4FOIbh',
    defaultMessage: '26',
  },
  q4option03: {
    id: 'dKScaY',
    defaultMessage: '11',
  },
  q4option04: {
    id: 'mmOYz/',
    defaultMessage: '15',
  },
  //////////
  q5option01: {
    id: 'VkZmCh',
    defaultMessage: 'Lost business and post breach response', //correct
  },
  q5option02: {
    id: '3Xj7V1',
    defaultMessage: 'Lost business and detection and escalation',
  },
  q5option03: {
    id: 'NZWD8x',
    defaultMessage: 'Detection and escalation and post breach response',
  },
  q5option04: {
    id: 'QIRcaz',
    defaultMessage: 'Detection and escalation and inflation',
  },
  ////////////
  q6option01: {
    id: 'm2gIOj',
    defaultMessage: '1%', //correct
  },
  q6option02: {
    id: 'HlDhAh',
    defaultMessage: '10%',
  },
  q6option03: {
    id: 'bOFH1p',
    defaultMessage: '16%',
  },
  q6option04: {
    id: 'GG+QTu',
    defaultMessage: '27%',
  },
  ////////////
  q7option01: {
    id: 'HlUFPm',
    defaultMessage: '78%', //correct
  },
  q7option02: {
    id: '+iy0zp',
    defaultMessage: '50%',
  },
  q7option03: {
    id: '5rkXhd',
    defaultMessage: '64%',
  },
  q7option04: {
    id: 'JbDL5p',
    defaultMessage: '83%',
  },
  /////////////
  q8option01: {
    id: 'sjBwli',
    defaultMessage: 'By the organization’s own security teams and tools', //correct
  },
  q8option02: {
    id: 'peITKF',
    defaultMessage: 'By a benign third party',
  },
  q8option03: {
    id: 'Lsyc9U',
    defaultMessage: 'By disclosure from the attacker',
  },
  q8option04: {
    id: 'xYaGzn',
    defaultMessage: 'By a customer or client reporting suspicious activity',
  },
  //////////
  q9option01: {
    id: '67y+im',
    defaultMessage: 'Incident response planning and testing', //correct
  },
  q9option02: {
    id: 'XO3/KT',
    defaultMessage: 'Threat detection and response',
  },
  q9option03: {
    id: '3+tvj5',
    defaultMessage: 'Employee training',
  },
  q9option04: {
    id: 'KG/2Tm',
    defaultMessage: 'Identity and access management',
  },
  /////////
  q10option01: {
    id: '2qMBq+',
    defaultMessage: 'Stolen or compromised credentials', //correct
  },
  q10option02: {
    id: 'FoH2il',
    defaultMessage: 'Malicious insider',
  },
  q10option03: {
    id: 'MRBNBk',
    defaultMessage: 'Phishing',
  },
  q10option04: {
    id: 'IM2aKh',
    defaultMessage: 'Social engineering',
  },
  //////////
  q11option01: {
    id: 'YGq69H',
    defaultMessage: '$1.5M', //correct
  },
  q11option02: {
    id: 'Ly4k5l',
    defaultMessage: '$1.2M',
  },
  q11option03: {
    id: '2YbPxi',
    defaultMessage: '$2.3M',
  },
  q11option04: {
    id: 'nDRHDY',
    defaultMessage: '$2.6M',
  },
  ///////
  q12option01: {
    id: 'tl46h5',
    defaultMessage: 'Customer personal identifiable information', //correct
  },
  q12option02: {
    id: 'nGkp4r',
    defaultMessage: 'Intellectual property',
  },
  q12option03: {
    id: '9H8rrR',
    defaultMessage: 'Operational data',
  },
  q12option04: {
    id: '6JACMK',
    defaultMessage: 'Financial records',
  },
  ////////
  q13option01: {
    id: '+IqeUN',
    defaultMessage: '$227K',
  },
  q13option02: {
    id: 'CulGDn',
    defaultMessage: '$307K',
  },
  q13option03: {
    id: 't6dxT4',
    defaultMessage: '$360K',
  },
  q13option04: {
    id: 'o4I2zk',
    defaultMessage: '$430K', //correct
  },
  ////////
  q14option01: {
    id: 'PEmB7u',
    defaultMessage: '15 days',
  },
  q14option02: {
    id: 'Toq4cb',
    defaultMessage: '24 days',
  },
  q14option03: {
    id: 'CbMY2Z',
    defaultMessage: '26 days', //correct
  },
  q14option04: {
    id: '2PB+P1',
    defaultMessage: '29 days',
  },
  /////////
  q15option01: {
    id: 'vTHBq9',
    defaultMessage: 'Multiple environments', //correct
  },
  q15option02: {
    id: 'zO7JGG',
    defaultMessage: 'Public cloud',
  },
  q15option03: {
    id: 'LD0z2p',
    defaultMessage: 'Private cloud',
  },
  q15option04: {
    id: 'vQ3rjY',
    defaultMessage: 'On premises',
  },
  //////////
  q16option01: {
    id: '/38DNE',
    defaultMessage: 'Log management', //correct
  },
  q16option02: {
    id: 'ogLt9g',
    defaultMessage: 'Firewalls and antivirus software',
  },
  q16option03: {
    id: '1E7cxh',
    defaultMessage: 'User authentication',
  },
  q16option04: {
    id: 'Msai6r',
    defaultMessage: 'Physical security',
  },
  //////
  q17option01: {
    id: 'LilyzK',
    defaultMessage: 'Synthetic data generation', //correct
  },
  q17option02: {
    id: 'htdmpO',
    defaultMessage: 'Encryption',
  },
  q17option03: {
    id: 'Pykw0h',
    defaultMessage: 'Substitution',
  },
  q17option04: {
    id: 'MHWP0R',
    defaultMessage: 'Shuffling',
  },
  //////
  q18option01: {
    id: 'cSeCpg',
    defaultMessage: '"Sneakers"', //correct,
  },
  q18option02: {
    id: 'u5MPxM',
    defaultMessage: '"Hackers"',
  },
  q18option03: {
    id: 'i/55qc',
    defaultMessage: '"The Matrix"',
  },
  q18option04: {
    id: 'hptG40',
    defaultMessage: '"WarGames"',
  },
  ////////
  q19option01: {
    id: 'IM2aKh',
    defaultMessage: 'Social engineering', //correct
  },
  q19option02: {
    id: 'nuywgP',
    defaultMessage: 'Phishing attacks',
  },
  q19option03: {
    id: 'oFlCfK',
    defaultMessage: 'Distributed denial of service (DDoS) attacks',
  },
  q19option04: {
    id: '649i0s',
    defaultMessage: 'Structured Query Language (SQL) injection',
  },

  q20option01: {
    id: 'i/55qc',
    defaultMessage: '"The Matrix"', //correct
  },
  q20option02: {
    id: 'oEsYVd',
    defaultMessage: '"Alien"',
  },
  q20option03: {
    id: '3gJ5yU',
    defaultMessage: '"Tron"',
  },
  q20option04: {
    id: 'L4GzOJ',
    defaultMessage: '"Star Wars"',
  },

  q21option01: {
    id: 'wfQA44',
    defaultMessage: 'DEF CON', //correct
  },
  q21option02: {
    id: 'KxpFDR',
    defaultMessage: 'RSA Conference',
  },
  q21option03: {
    id: '1ZvuXv',
    defaultMessage: 'Black Hat USA',
  },
  q21option04: {
    id: 'hX9ges',
    defaultMessage: 'Cyber Expo Vegas',
  },
  //help guideline
  helpGuideline: {
    id: 'MqQZuU',
    defaultMessage: 'Lifelines:',
  },
  helpLabel: {
    id: '8SiAzc',
    defaultMessage: 'Try this one',
  },
  buttonHelp1: {
    id: 'zC3kPK',
    defaultMessage: 'Ask for help',
  },
  buttonHelp2: {
    id: '/9D1vj',
    defaultMessage: 'Double the chance',
  },
  // results data
  resultsFinalResult: {
    id: 'YEqrOF',
    defaultMessage: 'Final results',
  },
  resultsDescription01: {
    id: '6ICTwz',
    defaultMessage: 'You got',
  },
  resultsDescription02: {
    id: 'JKQ8DN',
    defaultMessage: 'out of',
  },
  resultsDescription03: {
    id: '1YvgY9',
    defaultMessage: 'questions correct!',
  },

  resultsDescription04: {
    id: '2WGePf',
    defaultMessage:
      'Hungry for more knowledge? Download this year’s Cost of a Data Breach Report. You’ll be able to dig into essential insights, learn what your organization is up against and how to mitigate the risks. ',
  },

  resultsButtonReport: {
    id: 'Toy1gi',
    defaultMessage: 'Read the report',
  },
});

export default messages;
